module.exports = __webpack_public_path__ + "img/empty-img.f020768f.png";